import type { ButtonHTMLAttributes } from 'react';
import WdsButton, { type ButtonHierarchy } from './shared/components/ui/Button';

type Variant = 'primary' | 'secondary' | 'danger' | 'ghost';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  /** Target sentuh besar untuk POS tablet (md = WDS md; lg = WDS xl, min 48 px). */
  size?: 'md' | 'lg';
}

const HIERARCHY: Record<Variant, { hierarchy: ButtonHierarchy; destructive: boolean }> = {
  primary: { hierarchy: 'primary', destructive: false },
  secondary: { hierarchy: 'secondary', destructive: false },
  danger: { hierarchy: 'primary', destructive: true },
  ghost: { hierarchy: 'text', destructive: false },
};

/** Tombol SafePOS = tombol WDS (hierarchy dari `variant`, ukuran dari `size`). */
export function Button({ variant = 'primary', size = 'md', className, ...props }: ButtonProps) {
  const h = HIERARCHY[variant];
  return (
    <WdsButton
      hierarchy={h.hierarchy}
      destructive={h.destructive}
      size={size === 'lg' ? 'xl' : 'md'}
      variant="custom"
      className={[size === 'lg' ? 'min-h-touch' : '', className ?? ''].filter(Boolean).join(' ')}
      {...props}
    />
  );
}
